
import { css } from 'lit';
export default css`
pc-tabbed-nav{
  display:block;
}

  pc-tabbed-nav ul{
    list-style:none;
  }

  pc-tabbed-nav button{
    background:transparent;
    border:0;
    padding:var(--spacing-0);
  }

  pc-tabbed-nav .tablist{
    display:grid;
    grid-auto-flow:column;
    width:100%;
    overflow-x:auto;
    padding-left:var(--spacing-0);
    margin-bottom:var(--spacing-16);
    position:relative;
    z-index:1;
  }

  @media (min-width: 992px){
    pc-tabbed-nav .tablist{
      width:80%;
      margin:0 auto var(--spacing-24) auto;
    }
  }

  pc-tabbed-nav .tablist:not(.small) li:after{
        content:'';
        display:block;
        height:2px;
        width:100%;
        background:var(--purple-medium-neutral);
        transform:translateY(-3.5px);
      }

  pc-tabbed-nav .tablist li:hover button[role='tab']{
    color:var(--primary-eggplant);
  }

  pc-tabbed-nav .tablist button[role='tab']{
    color:var(--neutral-medium-gray);
    text-align:center;
    font-family:var(--ff-inter);
    font-size:var(--fs-base);
    font-weight:var(--fw-normal);
    line-height:var(--lh-h3);
    width:100%;
    min-width:150px;
    transition:0.3s ease;
    cursor:pointer;
  }

  pc-tabbed-nav .tablist button[role='tab']::after{
      content:'';
      height:6px;
      width:100%;
      border-radius:8px;
      background:transparent;
      display:block;
      margin-top:var(--spacing-4);
      transition:0.3s ease;
    }

  pc-tabbed-nav .tablist button[role='tab'].active{
      color:var(--primary-eggplant);
      font-weight:var(--fw-medium);
    }

  pc-tabbed-nav .tablist button[role='tab'].active:after{
        background:var(--purple-indigo);
        position:relative;
        z-index:10;
      }

  @media (min-width: 992px){
    pc-tabbed-nav .tablist button[role='tab']{
      font-size:var(--fs-h5);
    }
    pc-tabbed-nav .tablist button[role='tab']::after{
      margin-top:var(--spacing-6);
    }
  }

  pc-tabbed-nav .tablist.small{
    display:flex;
    justify-content:center;
    gap:var(--spacing-6);
    width:auto;
    margin-top:var(--spacing-0);
    margin-bottom:var(--spacing-8);
  }

  pc-tabbed-nav .tablist.small button[role='tab']{
      min-width:auto;
      font-size:var(--fs-base);
    }

  pc-tabbed-nav .tablist.small button[role='tab']::after{
        height:2px;
        margin-top:var(--spacing-2);
      }

  pc-tabbed-nav .tablist.small .active{
      color:var(--primary-iris);
    }

  @media (min-width: 992px){
    pc-tabbed-nav .tablist.small{
      width:auto;
    }
      pc-tabbed-nav .tablist.small button[role='tab']{
        font-size:var(--fs-lg);
      }
  }
`;